import { Close } from '@mui/icons-material';
import { Button, IconButton, Modal, Typography } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';

import {
  ModalActionButtons,
  ModalBox,
  ModalContent,
  ModalHeader,
} from './CustomModal.styles';

const CustomModal = ({
  isOpen,
  onClose,
  title,
  content,
  cancelButtonText,
  confirmButtonText,
  confirmButtonAction,
  confirmButtonDisabled = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content: any;
  additionalInfo?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonAction: () => void;
  confirmButtonDisabled?: boolean;
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalBox>
        <ModalHeader>
          <Typography variant="h6" component="h2">
            {title ?? ''}
          </Typography>
          <IconButton onClick={onClose} size="small" aria-label="Fechar modal">
            <Close />
          </IconButton>
        </ModalHeader>

        <ModalContent>{content}</ModalContent>

        <ModalActionButtons
          container
          spacing={2}
          justifyContent="flex-end"
          mt={2}
        >
          <Grid>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => onClose()}
            >
              {cancelButtonText ?? 'Fechar'}
            </Button>
          </Grid>
          <Grid>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => confirmButtonAction()}
              disabled={confirmButtonDisabled}
            >
              {confirmButtonText ?? 'Salvar'}
            </Button>
          </Grid>
        </ModalActionButtons>
      </ModalBox>
    </Modal>
  );
};

export default CustomModal;
